import { createHookStore, STORE_NAMES } from '@namespace/helpers-store';

export interface LayoutStoreState {
  expandedComponentIds: string[];
}

export const initialState: LayoutStoreState = {
  expandedComponentIds: []
};

export const useLayoutStore = createHookStore(
  STORE_NAMES.CMS_LAYOUT,
  initialState
);
